import MarketingNav from "@/components/Layout/MarketingNav";
import MarketingFooter from "@/components/Layout/MarketingFooter";
import { useTheme } from "@/lib/theme";
import { Lock, ShieldCheck, KeySquare, FileText, Globe } from "lucide-react";

const ITEMS = [
  { i: Lock, t: "Encryption in transit & at rest", d: "All traffic over TLS. Sensitive secrets (payment gateway keys) are encrypted with a platform master key." },
  { i: KeySquare, t: "Token-based review links", d: "Cryptographically random, optionally password-protected, optionally expiring." },
  { i: ShieldCheck, t: "RBAC isolation", d: "Strict workspace isolation. Members are scoped to their own data only." },
  { i: FileText, t: "Audit logs", d: "Approval certificates and admin actions are immutable, time-stamped, attributable." },
  { i: Globe, t: "Global compliance posture", d: "GDPR-, DPDP-, CCPA-aware architecture. DPA and subprocessors disclosed." },
];

export default function Security() {
  const { branding } = useTheme();
  return (
    <div className="min-h-screen bg-background">
      <MarketingNav />
      <section className="max-w-7xl mx-auto px-6 sm:px-10 pt-20 pb-24">
        <div className="label-eyebrow mb-4">Security & Compliance</div>
        <h1 className="heading-display text-5xl sm:text-7xl mb-6 max-w-4xl">Treat your business data like the asset it is.</h1>
        <p className="text-muted-foreground text-lg max-w-2xl mb-16">
          We design {branding.platform_name} so that no engineer ever has to debug security on a Friday night.
        </p>
        <div className="grid md:grid-cols-2 gap-3">
          {ITEMS.map((p, i) => (
            <div key={i} className="border border-border p-8" data-testid={`security-card-${i}`}>
              <p.i className="w-6 h-6 text-primary mb-4" />
              <h3 className="font-bold text-2xl mb-2" style={{ fontFamily: "var(--font-heading)" }}>{p.t}</h3>
              <p className="text-muted-foreground text-sm">{p.d}</p>
            </div>
          ))}
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
